// dataLayer.js - Contact Click Tracking
// Pushes phone and email clicks to window.dataLayer.
// GA4 receives these clicks from the LJ Server-side Tracking pixel (phone_click / email_click),
// so this file must not also send them through gtag, or every click is counted twice.

(function() {
  'use strict';
  
  // Initialize dataLayer if it doesn't exist
  window.dataLayer = window.dataLayer || [];
  
  function trackContactClicks() {
    // Track phone clicks
    document.querySelectorAll('a[href^="tel:"]').forEach(function(link) {
      // Prevent duplicate tracking
      if (link.dataset.dlTracked === 'true') return;
      link.dataset.dlTracked = 'true';
      
      link.addEventListener('click', function() {
        var location = this.closest('header') ? 'header' : 
                       this.closest('footer') ? 'footer' : 'other';
        var phoneNumber = this.textContent.trim();

        window.dataLayer.push({
          event: 'phone_click',
          contact_type: 'phone',
          contact_value: phoneNumber,
          click_location: location
        });
      });
    });
    
    // Track email clicks
    document.querySelectorAll('a[href^="mailto:"]').forEach(function(link) {
      // Prevent duplicate tracking
      if (link.dataset.dlTracked === 'true') return;
      link.dataset.dlTracked = 'true';
      
      link.addEventListener('click', function() {
        var location = this.closest('header') ? 'header' : 
                       this.closest('footer') ? 'footer' : 'other';
        var email = this.href.replace('mailto:', '');

        window.dataLayer.push({
          event: 'email_click',
          contact_type: 'email',
          contact_value: email,
          click_location: location
        });
      });
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackContactClicks);
  } else {
    trackContactClicks();
  }
  
  // Re-initialize for Shopify theme editor section loads
  document.addEventListener('shopify:section:load', trackContactClicks);
})();
